import type { SectionColor } from '@shared/types'
import { COLOR_GRADES, SECTION_COLOR_ORDER } from '@shared/colorGrades'
import { Check } from 'lucide-react'

export function ColorSwatchPicker({
  value,
  onChange,
}: {
  value: SectionColor
  onChange: (c: SectionColor) => void
}) {
  return (
    <div className="flex flex-wrap gap-1.5">
      {SECTION_COLOR_ORDER.map((color) => {
        const def = COLOR_GRADES[color]
        const active = value === color
        return (
          <button
            key={color}
            type="button"
            title={def.label}
            onClick={() => onChange(color)}
            className={`relative w-6 h-6 rounded-full border-2 transition-transform hover:scale-110 ${
              active ? 'border-white' : 'border-white/20'
            }`}
            style={{ backgroundColor: def.swatch }}
          >
            {active && (
              <Check
                size={12}
                strokeWidth={3}
                className="absolute inset-0 m-auto text-black/70 drop-shadow"
              />
            )}
          </button>
        )
      })}
    </div>
  )
}

export function ColorDot({ color, size = 8 }: { color: SectionColor; size?: number }) {
  return (
    <span
      className="inline-block rounded-full shrink-0"
      style={{ width: size, height: size, backgroundColor: COLOR_GRADES[color].swatch }}
    />
  )
}
